import { NextPage } from 'next';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import HeadMeta from '@/components/static-pages/HeadMeta';
import GPSContent, { ILoginProps } from '@/components/templates/gps/GPSContent';
import { loginUser } from '@/redux/modules/auth';
import { selectAuth } from '@/redux/modules/auth/selectors';
import { ILoginForm } from '@/services/types/auth/ILoginForm';
import { loadZubieUrl } from '@/services/zubie';
import { getReCaptchaToken } from '@/utility/recaptcha';
import { triggerLoginModal } from '@/utility/triggerLoginModal';

const GPS: NextPage = () => {
  const dispatch = useDispatch();
  const onLogin = useCallback((data: ILoginForm) => dispatch(loginUser(data)), [dispatch]);
  const auth = useSelector(selectAuth);

  const openZubieCheckout = async () => {
    const zubieUrlDetails = await loadZubieUrl();

    if (zubieUrlDetails && zubieUrlDetails.redirect_url) {
      const newWindow = window.open(zubieUrlDetails.redirect_url, '_blank');
      if (!newWindow) {
        // Weird fix for safari blocking new tabs ¯\_(ツ)_/¯
        window.location.href = zubieUrlDetails.redirect_url;
      }
    }
  };

  const loginFormProps: ILoginProps = {
    isModal: true,
    onLogin: onLogin,
    isLoading: auth.isLoggingIn,
    error: auth.error,
    reCaptchaToken: getReCaptchaToken(),
    isAuthenticated: auth.isAuthenticated,
  };

  return (
    <>
      <HeadMeta
        title="Outdoorsy track your rig"
        description="Track your rig with Zubie"
        noindex={true}
      />
      <GPSContent
        openZubieCheckout={openZubieCheckout}
        triggerLoginModal={triggerLoginModal}
        loginFormProps={loginFormProps}
      />
    </>
  );
};

export default GPS;
